import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
// Lazy load shared chart components
const SharedPieChart = React.lazy(() => import("../../Sharedpiechart"));
const TITLE =
  "حاسبة الاحتمالات - احسب نسبة النجاح والفشل من عدد المحاولات";
const DESCRIPTION =
  "حاسبة الاحتمالات المجانية تساعدك على حساب النسبة المئوية للنجاح والفشل بناءً على عدد النجاحات والإخفاقات. أداة دقيقة لحساب الاحتمالات في الإحصاء والرياضيات.";
const KEYWORDS =
  "حاسبة الاحتمالات, حساب الاحتمال, نسبة النجاح, نسبة الفشل, حاسبة النسب المئوية, احتمال النجاح, احتمال الفشل, حاسبة الإحصاء";
const OG_URL = "https://do-calculate.com/calculator/ar/probability";
function Calculator() {
  // Calculator State
  const [successes, setSuccesses] = useState("");
  const [failures, setFailures] = useState("");
  const [successPercent, setSuccessPercent] = useState("");
  const [failurePercent, setFailurePercent] = useState("");
  const [error, setError] = useState("");
  const [showChart, setShowChart] = useState(false);
  const [lastChanged, setLastChanged] = useState("");
  // Handle calculation when values change
  const handleCalculate = () => {
    setError("");
    // Count-based calculation (both successes and failures entered)
    if (successes !== "" && failures !== "") {
      const succ = parseFloat(successes);
      const fail = parseFloat(failures);
      if (isNaN(succ) || isNaN(fail) || succ < 0 || fail < 0) {
        setError("الرجاء إدخال قيم صحيحة وغير سالبة");
        setShowChart(false);
        return;
      }
      const total = succ + fail;
      if (total === 0) {
        setError("مجموع النجاحات والإخفاقات يجب أن يكون أكبر من صفر");
        setShowChart(false);
        return;
      }
      const succPct = (succ / total) * 100;
      const failPct = (fail / total) * 100;
      setSuccessPercent(succPct.toFixed(2));
      setFailurePercent(failPct.toFixed(2));
      setShowChart(true);
    }
    // Success count + failure percent calculation
    else if (successes !== "" && failurePercent !== "") {
      const succ = parseFloat(successes);
      const failPct = parseFloat(failurePercent);
      if (isNaN(succ) || isNaN(failPct) || succ < 0 || failPct < 0 || failPct > 100) {
        setError("الرجاء إدخال قيم صحيحة (النسبة المئوية بين 0-100)");
        setShowChart(false);
        return;
      }
      const succPct = 100 - failPct;
      if (succPct <= 0) {
        setError("نسبة النجاح يجب أن تكون أكبر من صفر");
        setShowChart(false);
        return;
      }
      const fail = (succ * failPct) / succPct;
      setFailures(fail.toFixed(2));
      setSuccessPercent(succPct.toFixed(2));
      setShowChart(true);
    }
    // Success count + success percent calculation
    else if (successes !== "" && successPercent !== "") {
      const succ = parseFloat(successes);
      const succPct = parseFloat(successPercent);
      if (isNaN(succ) || isNaN(succPct) || succ < 0 || succPct <= 0 || succPct > 100) {
        setError("الرجاء إدخال قيم صحيحة (النسبة المئوية بين 0-100)");
        setShowChart(false);
        return;
      }
      const failPct = 100 - succPct;
      const total = succ / (succPct / 100);
      const fail = total - succ;
      setFailures(fail.toFixed(2));
      setFailurePercent(failPct.toFixed(2));
      setShowChart(true);
    }
    // Failure count + success percent calculation
    else if (failures !== "" && successPercent !== "") {
      const fail = parseFloat(failures);
      const succPct = parseFloat(successPercent);
      if (isNaN(fail) || isNaN(succPct) || fail < 0 || succPct < 0 || succPct >= 100) {
        setError("الرجاء إدخال قيم صحيحة (النسبة المئوية بين 0-100)");
        setShowChart(false);
        return;
      }
      const failPct = 100 - succPct;
      if (failPct <= 0) {
        setError("نسبة الفشل يجب أن تكون أكبر من صفر");
        setShowChart(false);
        return;
      }
      const succ = (fail * succPct) / failPct;
      setSuccesses(succ.toFixed(2));
      setFailurePercent(failPct.toFixed(2));
      setShowChart(true);
    }
    // Failure count + failure percent calculation
    else if (failures !== "" && failurePercent !== "") {
      const fail = parseFloat(failures);
      const failPct = parseFloat(failurePercent);
      if (isNaN(fail) || isNaN(failPct) || fail < 0 || failPct <= 0 || failPct > 100) {
        setError("الرجاء إدخال قيم صحيحة (النسبة المئوية بين 0-100)");
        setShowChart(false);
        return;
      }
      const succPct = 100 - failPct;
      const total = fail / (failPct / 100);
      const succ = total - fail;
      setSuccesses(succ.toFixed(2));
      setSuccessPercent(succPct.toFixed(2));
      setShowChart(true);
    }
    else {
      setError("الرجاء إدخال قيمتين على الأقل للحساب");
      setShowChart(false);
    }
  };
  const handleReset = () => {
    setSuccesses("");
    setFailures("");
    setSuccessPercent("");
    setFailurePercent("");
    setError("");
    setShowChart(false);
    setLastChanged("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div>
          <h2 style={{ fontSize: "18px" }}>طريقة حساب الاحتمالات</h2>
          <p>الاحتمال هو قياس فرصة حدوث حدث معين، ويُعبر عنه عادة كنسبة مئوية أو ككسر.</p>
          <p> لحساب احتمالات النجاح والفشل، يمكنك اتباع الخطوات التالية:</p>
          <ul>
            <li> حدد عدد النجاحات وعدد الإخفاقات في التجربة أو الحدث الذي ترغب في تحليله.</li>
            <li> استخدم الحاسبة لإدخال عدد النجاحات وعدد الإخفاقات.</li>
            <li> اضغط على زر "احسب" للحصول على نسب النجاح والفشل.</li>
            <li> ستظهر لك النسب المئوية للنجاح والفشل بناءً على الأعداد التي أدخلتها.</li>
          </ul>
          <hr />
        </div>
      </div>
      <MobileUnderCalAds />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            {/* Main Calculator */}
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    حاسبة الاحتمالات (% نجاح وفشل)
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <p style={{ fontSize: "14px", color: "#666" }}>
                    أدخل عدد النجاحات والإخفاقات، أو أدخل عدد واحد ونسبة مئوية واحدة لحساب الحقول المتبقية.
                  </p>
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div className="form-group mb-3">
                        <label >
                          <b>عدد النجاحات:</b>
                        </label>
                        <input
                          type="number"
                          placeholder="عدد النجاحات"
                          value={successes}
                          onChange={(e) => {
                            setSuccesses(e.target.value);
                            setLastChanged("successes");
                          }}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div className="form-group mb-3">
                        <label >
                          <b>عدد الإخفاقات:</b>
                        </label>
                        <input
                          type="number"
                          placeholder="عدد الإخفاقات"
                          value={failures}
                          onChange={(e) => {
                            setFailures(e.target.value);
                            setLastChanged("failures");
                          }}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div className="form-group mb-3">
                        <label >
                          <b>% احتمال النجاح:</b>
                        </label>
                        <input
                          type="number"
                          placeholder="نسبة النجاح %"
                          value={successPercent}
                          onChange={(e) => {
                            setSuccessPercent(e.target.value);
                            setLastChanged("successPercent");
                          }}
                          className="form-control"
                          step="0.01"
                          min="0"
                          max="100"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div className="form-group mb-3">
                        <label >
                          <b>% احتمال الفشل:</b>
                        </label>
                        <input
                          type="number"
                          placeholder="نسبة الفشل %"
                          value={failurePercent}
                          onChange={(e) => {
                            setFailurePercent(e.target.value);
                            setLastChanged("failurePercent");
                          }}
                          className="form-control"
                          step="0.01"
                          min="0"
                          max="100"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-2 mb-3">
                    <button
                      className="btn btn-success"
                      onClick={handleCalculate}
                    >
                      احسب
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={handleReset}
                    >
                      إعادة تعيين
                    </button>
                  </div>
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {showChart && successPercent !== "" && failurePercent !== "" && (
                          <>
                            <div className="result-box p-3 mb-3 bg-light border">
                              <h3 style={{ fontSize: "18px", color: "#28a745" }}>
                                <b>احتمال النجاح: {successPercent}%</b>
                              </h3>
                              {successes !== "" && (
                                <p style={{ fontSize: "16px", color: "#666" }}>
                                  عدد النجاحات: {successes}
                                </p>
                              )}
                            </div>
                            <div className="result-box p-3 mb-3 bg-light border">
                              <h3 style={{ fontSize: "18px", color: "#dc3545" }}>
                                <b>احتمال الفشل: {failurePercent}%</b>
                              </h3>
                              {failures !== "" && (
                                <p style={{ fontSize: "16px", color: "#666" }}>
                                  عدد الإخفاقات: {failures}
                                </p>
                              )}
                            </div>
                            {successes !== "" && failures !== "" && (
                              <div className="result-box p-3 mb-3 bg-info text-black">
                                <p style={{ fontSize: "16px", margin: 0 }}>
                                  <b>المجموع الكلي:</b> {(parseFloat(successes) + parseFloat(failures)).toFixed(2)} محاولة
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                {showChart && successPercent && failurePercent && (
                  <React.Suspense
                    fallback={
                      <div className="text-center p-3">
                        جاري تحميل الرسم البياني...
                      </div>
                    }
                  >
                    <SharedPieChart
                      firstLabel="احتمال النجاح"
                      secondLabel="احتمال الفشل"
                      firstValue={successPercent}
                      secondValue={failurePercent}
                      firstColor="#28a745"
                      secondColor="#dc3545"
                      title="توزيع الاحتمالات"
                    />
                  </React.Suspense>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كيفية استخدام حاسبة الاحتمالات
              </div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>ما هي حاسبة الاحتمالات؟</u>
                  </h2>
                  <p>
                    حاسبة الاحتمالات هي أداة رياضية مجانية وسهلة الاستخدام تساعدك على حساب النسبة المئوية للنجاح والفشل في حدث ذي نتيجتين محتملتين. تُستخدم هذه الحاسبة على نطاق واسع في الإحصاء، والرياضيات، والبحث العلمي، وتحليل البيانات.
                  </p>
                  <p>
                    ما يميز هذه الحاسبة هو قدرتها على العمل في اتجاهين: يمكنك إدخال الأعداد لحساب النسب المئوية، أو إدخال النسب المئوية لحساب الأعداد. هذه المرونة تجعلها أداة قوية للتحليل والتخطيط في مختلف المجالات.
                  </p>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>كيفية استخدام الحاسبة:</u>
                  </h2>
                  <p>
                    الحاسبة تتيح لك أربع طرق مختلفة للحساب:
                  </p>
                  <ol>
                    <li>
                      <strong>من الأعداد إلى النسب المئوية:</strong> أدخل عدد النجاحات وعدد الإخفاقات، وستحسب الحاسبة النسبة المئوية لكل منهما تلقائياً.
                    </li>
                    <li>
                      <strong>من عدد النجاحات ونسبة الفشل:</strong> أدخل عدد النجاحات والنسبة المئوية للفشل، وستحسب الحاسبة عدد الإخفاقات ونسبة النجاح.
                    </li>
                    <li>
                      <strong>من عدد النجاحات ونسبة النجاح:</strong> أدخل عدد النجاحات والنسبة المئوية للنجاح، وستحسب الحاسبة عدد الإخفاقات ونسبة الفشل.
                    </li>
                    <li>
                      <strong>من عدد الإخفاقات والنسب المئوية:</strong> أدخل عدد الإخفاقات وأي نسبة مئوية، وستحسب الحاسبة باقي القيم.
                    </li>
                  </ol>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>معادلة حساب الاحتمالات:</u>
                  </h2>
                  <p>
                    تعتمد حاسبة الاحتمالات على المعادلات الأساسية التالية:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>احتمال النجاح = (عدد النجاحات ÷ المجموع الكلي) × 100%</strong>
                    <br />
                    <strong>احتمال الفشل = (عدد الإخفاقات ÷ المجموع الكلي) × 100%</strong>
                    <br />
                    <strong>احتمال النجاح + احتمال الفشل = 100%</strong>
                  </div>
                  <p>
                    <strong>مثال عملي:</strong> إذا كان لديك 60 محاولة ناجحة و40 محاولة فاشلة، فإن:
                  </p>
                  <ul>
                    <li>المجموع الكلي = 60 + 40 = 100 محاولة</li>
                    <li>احتمال النجاح = (60 ÷ 100) × 100% = 60%</li>
                    <li>احتمال الفشل = (40 ÷ 100) × 100% = 40%</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>استخدامات حاسبة الاحتمالات:</u>
                  </h2>
                  <ul>
                    <li>حساب معدلات النجاح والفشل في الامتحانات الدراسية</li>
                    <li>تحليل نتائج التجارب العلمية والبحثية</li>
                    <li>حساب معدلات التحويل في التسويق والمبيعات</li>
                    <li>تقييم فعالية الحملات الإعلانية</li>
                    <li>حساب معدلات الجودة والعيوب في التصنيع</li>
                    <li>تحليل البيانات الإحصائية في الأبحاث</li>
                    <li>حساب احتمالات الأحداث في الألعاب الرياضية</li>
                    <li>تقييم المخاطر في المشاريع والاستثمارات</li>
                    <li>حساب معدلات الاستجابة في الاستبيانات</li>
                    <li>تحليل أداء الموظفين والفرق</li>
                    <li>التخطيط وتحديد الأهداف بناءً على البيانات التاريخية</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>الفرق بين الاحتمال والنسبة (Odds):</u>
                  </h2>
                  <p>
                    في الحياة اليومية، قد نستخدم كلمة "احتمالات" بشكل عام، لكن في علم الإحصاء هناك فرق مهم:
                  </p>
                  <ul>
                    <li>
                      <strong>الاحتمال (Probability):</strong> هو نسبة مئوية تعبر عن فرصة حدوث شيء ما من إجمالي المحاولات. مثال: احتمال النجاح 60% يعني 60 من كل 100 محاولة تنجح.
                    </li>
                    <li>
                      <strong>النسبة (Odds):</strong> هي نسبة النجاحات إلى الإخفاقات. مثال: إذا كان لديك 60 نجاح و40 فشل، فإن النسبة هي 60:40 أو 3:2.
                    </li>
                  </ul>
                  <p>
                    هذه الحاسبة تحسب الاحتمالات (Probability) وليس النسب (Odds)، مما يجعلها أكثر سهولة في الفهم والاستخدام العملي.
                  </p>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>مميزات حاسبة الاحتمالات:</u>
                  </h2>
                  <ul>
                    <li>حسابات ثنائية الاتجاه (من الأعداد للنسب والعكس)</li>
                    <li>واجهة سهلة وبديهية للاستخدام</li>
                    <li>دقة عالية في الحسابات</li>
                    <li>نتائج فورية وواضحة</li>
                    <li>رسم بياني دائري توضيحي</li>
                    <li>أداة مجانية 100% بدون اشتراك</li>
                    <li>متوافقة مع جميع الأجهزة</li>
                    <li>زر إعادة تعيين لبدء حساب جديد بسهولة</li>
                    <li>عرض المجموع الكلي للمحاولات</li>
                    <li>التحقق من صحة المدخلات تلقائياً</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>نصائح للاستخدام الأمثل:</u>
                  </h2>
                  <ol>
                    <li>تأكد من إدخال قيمتين على الأقل من القيم الأربع المتاحة</li>
                    <li>النسب المئوية يجب أن تكون بين 0 و 100</li>
                    <li>الأعداد يجب أن تكون غير سالبة</li>
                    <li>استخدم زر "إعادة تعيين" لمسح جميع الحقول وبدء حساب جديد</li>
                    <li>راجع النتائج للتأكد من منطقيتها قبل استخدامها</li>
                    <li>احفظ النتائج المهمة للرجوع إليها لاحقاً</li>
                    <li>استخدم الرسم البياني لفهم التوزيع بصرياً</li>
                  </ol>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>أمثلة عملية:</u>
                  </h2>
                  <div className="p-3 mb-3 bg-light border">
                    <p><strong>مثال 1:</strong> لديك 80 طالباً، نجح منهم 64. ما احتمال النجاح والفشل؟</p>
                    <p><strong>الحل:</strong> أدخل 64 في خانة النجاحات و16 في خانة الإخفاقات.</p>
                    <p><strong>النتيجة:</strong> احتمال النجاح = 80%، احتمال الفشل = 20%</p>
                  </div>
                  <div className="p-3 mb-3 bg-light border">
                    <p><strong>مثال 2:</strong> تريد معرفة كم عدد المحاولات الناجحة إذا كان لديك 200 محاولة واحتمال النجاح 75%؟</p>
                    <p><strong>الحل:</strong> أدخل 75 في خانة % احتمال النجاح، ثم احسب عدد النجاحات من المجموع الكلي.</p>
                    <p><strong>النتيجة:</strong> عدد النجاحات = 150، عدد الإخفاقات = 50</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;